import { render, staticRenderFns } from "./modalEditarDatosEquipo.vue?vue&type=template&id=d5fa0154&"
import script from "./modalEditarDatosEquipo.vue?vue&type=script&lang=js&"
export * from "./modalEditarDatosEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports